import React from 'react'
import PropTypes from 'prop-types'

/**
 * The FormattedPhone's component.
 */
const FormattedPhoneComponent = props => {
  const { phone } = props

  if (!phone) return null

  const splitInBlocks = digits => {
    const lengthDigits = digits.length
    const patterns = {
      8: [4, 4],
      9: [3, 3, 3],
      10: [3, 3, 4],
      11: [3, 4, 4],
      12: [4, 4, 4],
      13: [3, 3, 3, 4],
      14: [3, 3, 4, 4],
      15: [3, 4, 4, 4]
    }

    const pattern = patterns[lengthDigits]

    if (pattern) {
      let i = 0
      return pattern.map(size => digits.slice(i, (i += size))).join(' ')
    }

    return digits.match(/.{1,3}/g).join(' ')
  }

  const pretty = splitInBlocks(phone)

  return <>+{pretty}</>
}

FormattedPhoneComponent.propTypes = {
  phone: PropTypes.string
}

export default FormattedPhoneComponent
